import { useQuery } from '@tanstack/react-query';
import { fetchSports } from '../../api/sportsbook-api';
import { RefetchInterval, StaleTime } from '../../sportsbook-constants';
import { SportDto } from '../../api/sbapi/sbapi-api-model';
import { SPORTSBOOK_QUERY_KEY } from '../queries-constants';

type Options<TData> = {
	select?: (data: SportDto[]) => TData;
	staleTime?: StaleTime;
	refetchInterval?: RefetchInterval;
};

export const createSportsQueryKey = () => [SPORTSBOOK_QUERY_KEY, 'sports'];
const useQuerySports = <TData = SportDto[]>(options?: Options<TData>) =>
	useQuery({
		queryKey: createSportsQueryKey(),
		queryFn: fetchSports,
		staleTime: options?.staleTime ?? StaleTime.ZERO,
		refetchInterval: options?.refetchInterval,
		select: options?.select,
		meta: {
			errorMessage: 'Failed to fetch sports'
		}
	});

const sliceSports = (sports: SportDto[]) => sports.slice(0, 8);
export const useQueryPopularSports = (options?: Omit<Options<SportDto>, 'select'>) =>
	useQuerySports({
		...options,
		select: sliceSports
	});

export default useQuerySports;
